export const EMAIL_REGEX =
  // eslint-disable-next-line no-useless-escape
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{1,}))$/;
export const NO_SPACES_REGEX = /^\S*$/;
export const AT_LEAST_ONE_LOWERCASE_REGEX = /^(?=.*[a-z])/;
export const AT_LEAST_ONE_UPPERCASE_REGEX = /^(?=.*[A-Z])/;
export const AT_LEAST_ONE_NUMBER_REGEX = /^(?=.*[0-9])/;
export const AT_LEAST_ONE_SPECIAL_CHARACTER_REGEX = /^(?=.*[?.,!_\-~$%+=@#^&])/;
export const ONLY_LETTERS_REGEX = /^[aA-zZ\s]+$/;
